import { render, staticRenderFns } from "./RequestsCard.vue?vue&type=template&id=79ff297e&"
import script from "./RequestsCard.vue?vue&type=script&lang=js&"
export * from "./RequestsCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestsCard.vue?vue&type=style&index=0&id=79ff297e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports